import { RootState } from '@reducers';
import { createSelector } from 'reselect';
import { UserState } from '@reducers/users-item';
import { UsersState } from '@reducers/users-list';

// Users List
export const getUsersList = (state: RootState): UsersState => state.usersList;
export const getUsersData = createSelector(getUsersList, (users) => users?.data);
export const getUsersItems = createSelector(getUsersList, (users) => users?.data?.items);
export const getUsersTotal = createSelector(getUsersList, (users) => users?.data?.total);
export const getUsersError = createSelector(getUsersList, (users) => users?.error as Error);
export const getUsersFilter = createSelector(getUsersList, (users) => users?.filter);
export const getUsersLoading = createSelector(getUsersList, (users) => users?.loading);
export const getUsersGroupId = createSelector(getUsersList, (users) => users?.groupId);

// User Item
export const getUserItem = (state: RootState): UserState => state.usersItem;
export const getUserData = createSelector(getUserItem, (userData) => userData?.data);
export const getUserIsLoading = createSelector(getUserItem, (userData) => userData?.loading);
export const getUserSelectedGroupId = createSelector(getUserItem, (userData) => userData?.selectedGroupId);
export const getUserSelectedPermissionCode = createSelector(
  getUserItem, (userData) => userData?.selectedPermissionCode,
);
export const getUserIsPermissionUpdate = createSelector(getUserItem, (userData) => userData?.loading);
